import { put, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setHeadLossConsOptions } from '../store/options.actions'

export function* getHeadLossConsOptions() {
  const hardCodedOptions = [
    { id: 0, name: 'No' },
    { id: 1, name: 'Yes' },
    { id: 2, name: 'Unk' },
  ]
  try {
    yield put(setHeadLossConsOptions(hardCodedOptions))
  } catch (e) {
    yield put(throwPcrException(`getHeadLossConsOptions() error: ${e}`))
  }
}

export function* getHeadLossConsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getHeadLossConsOptions)
}
